/* eslint-disable no-use-before-define */

import {
  extractInput,
  isListLenLimitExceeded,
  initList,
  fetchUsers as _fetchUsers,
} from '@/shared/services/users'

/*
firebase index: collectionId, fields indexed
- search by mobile: users, isAdmin Ascending mobile Descending
- search by email: users, confirmed Ascending isAdmin Ascending email Ascending
- search by last name:  users, confirmed Ascending isAdmin Ascending lastName Ascending

test cases
+----------------+-----------------------------------------+
| type in        | expect to see unique matched results in |
+================+=========================================+
| '12'           | email and mobile cols                   |
+----------------+-----------------------------------------+
| 'ali' OR 'Ali' | full name (including last name)         |
+----------------+-----------------------------------------+
| 'ilmi'          | email col                               |
+----------------+-----------------------------------------+

*/

async function fetchUsers(_ctx, queryParams) {
  const data = await _fetchUsers(queryParams)
  const updatedList = updateList(data, queryParams)
  return { data: updatedList, isMore: isListLenLimitExceeded(updatedList) }
}

function updateList(data, queryParams) {
  const input = extractInput(queryParams)
  const { list } = queryParams
  return initList(input, list).concat(data)
}

export {
  // eslint-disable-next-line import/prefer-default-export
  fetchUsers,
}
